import React, { ReactNode, useReducer } from "react";
import { PlaidAction, PlaidContext, PlaidState, initialState } from "./PlaidContext";

export const PlaidProvider: React.FC<{ children: ReactNode }> = (props) => {
  const reducer = (state: PlaidState, action: PlaidAction): PlaidState => {
    switch (action.type) {
      case "SET_STATE":
        return { ...state, ...action.state };
      default:
        return { ...state };
    }
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  return <PlaidContext.Provider value={{ ...state, dispatch }}>{props.children}</PlaidContext.Provider>;
};

export default PlaidProvider;
